"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCache = void 0;

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _ = require("./");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var validateCache = function validateCache(settingsCache) {
  var versionKey = "@lce/local/versioning"
  /* Versioning */
  ;
  var localStorageVersionCache = localStorage.getItem(versionKey) || '{}';

  try {
    var localStorageVersionObj_1 = JSON.parse(localStorageVersionCache);

    if (!(0, _isEqual2["default"])(localStorageVersionObj_1, settingsCache)) {
      (0, _map2["default"])(Object.keys(settingsCache), function (settingsCacheKey) {
        var cacheObject = settingsCache === null || settingsCache === void 0 ? void 0 : settingsCache[settingsCacheKey];

        if (cacheObject && cacheObject !== (localStorageVersionObj_1 === null || localStorageVersionObj_1 === void 0 ? void 0 : localStorageVersionObj_1[settingsCacheKey])) {
          localStorage.removeItem(_.VersionKeys[settingsCacheKey]);
        }
      });
    }
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error("Error loading state at " + versionKey);
  }

  localStorage.setItem(versionKey, JSON.stringify(settingsCache));
};

exports.validateCache = validateCache;